import theme from '../../../theme';

const styles = {
  innerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.primary.dark,
  },
  typography: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
    width: '100%',
    margin: '0',
  },
};

export default styles;
